import { render, staticRenderFns } from "./ContentMain.vue?vue&type=template&id=0785d782&scoped=true&"
import script from "./ContentMain.vue?vue&type=script&lang=js&"
export * from "./ContentMain.vue?vue&type=script&lang=js&"
import style0 from "./ContentMain.vue?vue&type=style&index=0&id=0785d782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0785d782",
  null
  
)

export default component.exports